module.exports = __webpack_public_path__ + "img/vertical_6_2_3009.3b99ba3a.png";